import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import './index.css';
import Onboarding from './Onboarding';
import App from './App';
import { BrowserRouter } from 'react-router-dom' ;

Sentry.init({
  dsn: "https://d97db601b277425ca56db15d8253a070@o1291820.ingest.sentry.io/6513288",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render((
  <BrowserRouter>
    <App /> {/* The various pages will be displayed by the `Main` component. */}
  </BrowserRouter>
  ), document.getElementById('root')
);

// ReactDOM.render(
//   <React.StrictMode>
//     <Onboarding />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
